import { cn } from "@/lib/utils/helpers";
import companyFormStyles from "@/features/company/styles/companyAdd.module.css";
import { YardiInfoTooltip } from "../YardiInfoTooltip";
import { ConfigSubsection } from "./ConfigSubsection";

import type { ApiTokenEndpointSectionProps } from "../../../types";

export function ApiTokenEndpointSection({
    yardiConfigDisplayUrl,
    apiToken,
    generateToken,
    isLoading,
}: ApiTokenEndpointSectionProps) {
    return (
        <ConfigSubsection
            title="API Token & Endpoint"
            testId="company-config-api-token-endpoint-section"
        >
            <div className="grid grid-cols-1 items-end gap-6 md:grid-cols-2 lg:grid-cols-3">
                <div className="space-y-1.5 lg:col-span-1">
                    <label className="relative flex items-center gap-1.5 text-sm font-medium text-slate-700">
                        Api Url
                        <YardiInfoTooltip>Use this URL as the endpoint when making requests.</YardiInfoTooltip>
                    </label>
                    <input
                        type="text"
                        data-testid="company-config-api-url-input"
                        value={yardiConfigDisplayUrl}
                        disabled
                        className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 font-mono text-xs text-slate-500"
                    />
                </div>
                <div className="space-y-1.5 lg:col-span-1">
                    <label className="relative flex items-center gap-1.5 text-sm font-medium text-slate-700">
                        Api Token
                        <YardiInfoTooltip>
                            Put this token in the request header with the name token when you call the API.
                        </YardiInfoTooltip>
                    </label>
                    <input
                        type="text"
                        data-testid="company-config-api-token-input"
                        value={apiToken}
                        disabled
                        className="w-full truncate rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm text-slate-500"
                        placeholder="No token generated"
                    />
                </div>
                <div className="lg:col-span-1">
                    <button
                        type="button"
                        data-testid="company-config-generate-token-button"
                        onClick={generateToken}
                        disabled={isLoading}
                        className={cn(companyFormStyles.btnPrimary, "disabled:opacity-50")}
                    >
                        {apiToken ? "Refresh Token" : "Generate Token"}
                    </button>
                </div>
            </div>
        </ConfigSubsection>
    );
}
